import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types';

export type HobbyToolsClient = SupabaseClient<Database>;

/** One storage key for every app on the domain, so a single sign-in covers /, /40k/, … (ADR 0008/0009). */
export const AUTH_STORAGE_KEY = 'hobbytools-auth';

export function createHobbyToolsClient(url: string, publishableKey: string): HobbyToolsClient {
  return createClient<Database>(url, publishableKey, {
    auth: {
      flowType: 'pkce',
      storageKey: AUTH_STORAGE_KEY,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
}
